var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TabMenu',{attrs:{"active-tab-name":_vm.activeTab},on:{"change":_vm.onTabChange}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }